var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7567 34.1509L18.5384 38.699L14.0856 38.7932C12.7548 36.325 12 33.501 12 30.5C12 27.5981 12.7057 24.8615 13.9567 22.4519H13.9577L17.922 23.1787L19.6586 27.1192C19.2951 28.1788 19.097 29.3163 19.097 30.5C19.0971 31.7846 19.3298 33.0154 19.7567 34.1509Z",
    fill: "#FCFF6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6943 27.2307C46.8952 28.2893 47 29.3826 47 30.4999C47 31.7528 46.8683 32.975 46.6174 34.1538C45.7655 38.1653 43.5395 41.6682 40.4559 44.1471L40.4549 44.1461L35.4617 43.8913L34.755 39.4798C36.8011 38.2798 38.4002 36.4019 39.2425 34.1538H29.8848V27.2307H39.379H46.6943Z",
    fill: "#0085FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4549 44.146L40.4559 44.147C37.4569 46.5576 33.6472 47.9999 29.5001 47.9999C22.8357 47.9999 17.0415 44.2749 14.0857 38.7932L19.7569 34.1509C21.2347 38.0951 25.0395 40.9028 29.5001 40.9028C31.4174 40.9028 33.2136 40.3845 34.7549 39.4797L40.4549 44.146Z",
    fill: "#12AD63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6703 17.0288L35.001 21.6702C33.4059 20.6731 31.5202 20.0971 29.5001 20.0971C24.9385 20.0971 21.0625 23.0336 19.6587 27.1192L13.9577 22.4519H13.9568C16.8693 16.8365 22.7366 13 29.5001 13C33.7462 13 37.6395 14.5125 40.6703 17.0288Z",
    fill: "#E76C4B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d53a3dde41c0e3f3428bd8995b7cf9ba.svg";
export { ForwardRef as ReactComponent };